import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/activationCodeWhere.png'


const _hoisted_1 = { class: "thankYou" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide margin-30" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeStep(2))),
      class: "icon-warpit_icon_x closeIcon"
    }),
    _createElementVNode("img", {
      src: _imports_0,
      alt: _ctx.$t('accessibility.payment.code')
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("button", {
      class: "defaultButton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStep(2)))
    }, "OK")
  ]))
}